var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiresRearAxle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212.484,
    height: 99.173,
    viewBox: "0 0 212.484 99.173",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.806 68.2c-.8 6.81-4.81 11.9-10.56 13.46-1.47.4-2.43.84-2.34-1.64.47-12.62-9.98-23.04-22.54-22.71-12.49.33-22.28 11.01-21.28 23.56.21 2.66-.52 3.01-2.87 3.06-28 .57-55.99 1.24-83.99 1.91-1.59.04-2.44.16-2.01-2.13 1.83-9.53-2.02-18.17-9.96-23.16-7.16-4.49-16.94-4.3-23.75.46-7.89 5.52-11.26 13.98-9.06 23.51.48 2.1-.13 2.16-1.85 2.28-4.69.33-9.35.58-13.94-.74-5.53-1.58-7.63-4.39-7.63-10.16 0-4.68-.07-9.37.02-14.05.08-3.91 1.1-7.75 3.02-11.05 4.06-6.98 9.81-12.02 17.83-14.41 8.23-2.45 16.69-3.81 24.98-5.93 4.11-1.05 7.7-2.67 11.08-5.42 15.57-12.63 32.99-21.46 53.1-24.26 11.45-1.6 22.88-.4 34.29.6 10.53.92 20.92 2.77 31.26 4.92 2.24.46 4.48.9 6.8.88 2.91-.03 4.54 1.7 4.6 4.42.04 1.96.89 3.02 2.23 4.17 4.13 3.55 8.87 6.52 11.65 11.44.37.66.88.74 1.48.7 3.52-.24 4.64 2.11 5.27 4.93.94 4.19 1.34 8.47 1.53 12.74.23 5.11 1.76 9.89 3.15 14.72v4.78c-.72.95.05 2.15-.52 3.12h.01z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.806 68.2c-.18-1.1-.41-2.21.52-3.12v2.99c-.17.06-.34.11-.52.13z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.756 61.65c11.48 4.02 16.77 13.64 13.38 24.35-2.37 7.51-9.48 12.87-17.43 13.16-8.39.3-15.95-4.48-18.94-11.96-2.96-7.42-.95-15.85 4.99-21.3 2.38-2.18 5.12-3.59 8.21-4.41 1-.49 2.08-.22 3.12-.29 1.05-.05 2.1-.08 3.16 0 1.16.2 2.44-.45 3.51.45z",
    fill: "#EFDF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.076 60.73c10.33.27 18.62 8.86 18.28 18.96-.34 10.3-8.92 18.43-19.13 18.15-10.15-.28-18.35-8.83-18.06-18.84.3-10.42 8.69-18.53 18.91-18.27z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.346 61.4h-3.17c-.17-.22-.12-.39.13-.5.94-.31 1.89-.46 2.85-.04.17.08.26.18.26.32 0 .15-.02.23-.07.23v-.01z",
    fill: "#C09102"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.346 61.4c-.05-.19-.11-.37-.19-.54 1.24.09 2.63-.53 3.61.79-1.14-.08-2.28-.16-3.41-.25h-.01z",
    fill: "#857235"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.306 60.9c-.05.17-.09.34-.13.51-1.07.03-2.13.05-3.2.08.99-.85 2.17-.66 3.33-.59z",
    fill: "#8C752F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiresRearAxle);
export default __webpack_public_path__ + "static/media/tires-rear-axle.650e2ece67ae13881c3f94e5acc4e99d.svg";
export { ForwardRef as ReactComponent };